import { jsonToQueryString } from 'src/utils/url';
import { get } from 'src/utils/fetch';
export function fetchCatalogueInfo({ username }, options) {
    const querystring = jsonToQueryString({ username });
    return get(`/api/v4/catalogue/get_catalogue_info${querystring}`, undefined, options);
}
